var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "basic-container",
    [
      _c(
        "div",
        { staticClass: "search_group" },
        [
          _c("el-input", {
            attrs: { maxlength: 30, size: "small", placeholder: "分组标签" },
            model: {
              value: _vm.title,
              callback: function ($$v) {
                _vm.title = $$v
              },
              expression: "title",
            },
          }),
          _c(
            "el-select",
            {
              ref: "selectUpResId",
              attrs: { size: "small", clearable: "", placeholder: "请选择" },
              on: { clear: _vm.handleClear },
              model: {
                value: _vm.selectedId,
                callback: function ($$v) {
                  _vm.selectedId = $$v
                },
                expression: "selectedId",
              },
            },
            [
              _c("el-option", {
                key: "selectedId",
                attrs: {
                  hidden: "",
                  value: _vm.selectedId,
                  label: _vm.selectetName,
                },
              }),
              _c("el-tree", {
                attrs: {
                  data: _vm.deptTreeList,
                  props: _vm.defaultProps,
                  "expand-on-click-node": false,
                  "check-on-click-node": true,
                },
                on: { "node-click": _vm.handleNodeClick },
              }),
            ],
            1
          ),
          _c(
            "el-button",
            {
              attrs: { icon: "el-icon-search", size: "small", type: "primary" },
              on: { click: _vm.searchAct },
            },
            [_vm._v("搜索")]
          ),
        ],
        1
      ),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.listLoading,
              expression: "listLoading",
            },
          ],
          attrs: {
            "cell-style": { "text-align": "center" },
            "header-cell-style": { "text-align": "center" },
            "max-height": _vm.tableHeight,
            "element-loading-text": "加载中",
            border: "",
            data: _vm.tableData,
          },
        },
        [
          _c("el-table-column", {
            attrs: { prop: "groupName", label: "分组标签", width: "300" },
          }),
          _c("el-table-column", {
            attrs: { prop: "videoCount", label: "视频内数量", width: "300" },
          }),
          _c("el-table-column", {
            attrs: { prop: "deptName", label: "所属企业" },
          }),
          _c("el-table-column", {
            attrs: { fixed: "right", width: "250", label: "操作" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "auth",
                            rawName: "v-auth",
                            value: "contentmanage_grouping_detail",
                            expression: "'contentmanage_grouping_detail'",
                          },
                        ],
                        attrs: {
                          icon: "el-icon-edit",
                          size: "small",
                          type: "text",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.openEdit(scope.row)
                          },
                        },
                      },
                      [_vm._v("查看")]
                    ),
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "auth",
                            rawName: "v-auth",
                            value: "contentmanage_grouping_delete",
                            expression: "'contentmanage_grouping_delete'",
                          },
                        ],
                        attrs: {
                          icon: "el-icon-delete",
                          size: "small",
                          type: "text",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.delDiscount(scope.row)
                          },
                        },
                      },
                      [_vm._v("删除")]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.checkItem.id ? "查看详情" : "查看详情",
            visible: _vm.showEdit,
            "append-to-body": "",
            width: "50%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showEdit = $event
            },
          },
        },
        [
          _c(
            "el-alert",
            { attrs: { title: "", type: "info" } },
            [
              _c("template", { slot: "title" }, [
                _vm._v("\n         1、您可以在此改变该分组内的排序 "),
                _c("br"),
                _vm._v(
                  "\n         2、移出动作仅会将该视频移出分组，并不会删除该资源或改变该资源的状态\n    "
                ),
              ]),
            ],
            2
          ),
          _c(
            "el-table",
            { attrs: { data: _vm.gridData } },
            [
              _c("el-table-column", {
                attrs: {
                  type: "index",
                  width: "100",
                  label: "显示顺序",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: { prop: "name", label: "视频标题" },
              }),
              _c("el-table-column", {
                attrs: { prop: "coverImageUrl", label: "封面" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("img", {
                          staticStyle: { height: "50px" },
                          attrs: { src: scope.row.coverImageUrl },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "playInfo", label: "视频" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("img", {
                          staticStyle: { height: "50px" },
                          attrs: { src: scope.row.coverImageUrl },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "reviewStatus", label: "状态" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm._f("reviewStatus")(scope.row.reviewStatus)
                            ) +
                            "\n        "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { fixed: "right", width: "250", label: "操作" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "auth",
                                rawName: "v-auth",
                                value: "memberDiscount_change",
                                expression: "'memberDiscount_change'",
                              },
                            ],
                            attrs: {
                              icon: "el-icon-edit",
                              size: "small",
                              type: "text",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.groupSort(scope.row, "up")
                              },
                            },
                          },
                          [_vm._v("上移")]
                        ),
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "auth",
                                rawName: "v-auth",
                                value: "memberDiscount_change",
                                expression: "'memberDiscount_change'",
                              },
                            ],
                            attrs: {
                              icon: "el-icon-edit",
                              size: "small",
                              type: "text",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.groupSort(scope.row, "down")
                              },
                            },
                          },
                          [_vm._v("下移")]
                        ),
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "auth",
                                rawName: "v-auth",
                                value: "memberDiscount_delete",
                                expression: "'memberDiscount_delete'",
                              },
                            ],
                            attrs: {
                              icon: "el-icon-delete",
                              size: "small",
                              type: "text",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.groupSort(scope.row, "remove")
                              },
                            },
                          },
                          [_vm._v("移出")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "el-alert",
            { attrs: { title: "", type: "info" } },
            [
              _c("template", { slot: "title" }, [
                _vm._v(
                  "\n         1、上移：调换该条视频与上一顺序视频的显示顺序 "
                ),
                _c("br"),
                _vm._v(
                  "\n         2、下移：调换该条视频与下一顺序视频的显示顺序 "
                ),
                _c("br"),
                _vm._v(
                  "\n         3、移出：清除该条数据的分组标签，移出操作需有二次确认（移出仅为将该视频的分组标签清除）\n    "
                ),
              ]),
            ],
            2
          ),
          _c("div", {
            staticClass: "dialog-footer",
            attrs: { slot: "footer" },
            slot: "footer",
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }